module.exports = __webpack_public_path__ + "static/media/Spotify_Logo_RGB_Green.aacbec23.png";